import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FeedbackContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { majorClient } from '../client/majorClient';


export const useMajorCrud = () => {
  const { genericErrorFeedback } = React.useContext(FeedbackContext);

  const queryClient = useQueryClient();


  const likeMajor = useMutation({
    mutationKey: [cacheKeys.likeMajor],
    mutationFn: (id: number) => majorClient.likeMajor({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMajors],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMajor, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const unlikeMajor = useMutation({
    mutationKey: [cacheKeys.unlikeMajor],
    mutationFn: (id: number) => majorClient.unlikeMajor({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMajors],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMajor, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const ignoreMajor = useMutation({
    mutationKey: [cacheKeys.ignoreMajor],
    mutationFn: (id: number) => majorClient.ignoreMajor({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMajors],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getMajor, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    likeMajor: likeMajor,
    unlikeMajor: unlikeMajor,
    ignoreMajor: ignoreMajor,
  };
};
